import React, { ReactElement } from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory } from 'react-router-dom';
import { LinkButton } from '../../atoms';
import { useTranslation } from 'react-i18next';

export interface IBackButtonProps {
	text?: string;
	onClick?: () => void;
}

export function BackButton(props: IBackButtonProps): ReactElement {
	const { text, onClick } = props;
	const { t } = useTranslation('general');

	const history = useHistory();

	function handleClick(): void {
		if (onClick) onClick();
		else history.go(-1);
	}

	return (
		<LinkButton onClick={handleClick} className="back-button">
			<ArrowBackIcon />
			{text ? text : t('goBack')}
		</LinkButton>
	);
}
